import {
    postImportServiceClientLoading,
    postImportServiceClientRequest,
    postImportServiceClientSuccess,
    postImportServiceClientReject,
    postImportServiceClientReset
} from "../../actions/importServiceClient/post";

export const postImportServiceClient = (formData) => async (dispatch, getState) => {
    dispatch(postImportServiceClientLoading());
    try {
        const { data } = await postImportServiceClientRequest(formData, getState);
        dispatch(postImportServiceClientSuccess(data))
    } catch (error) {
        dispatch(postImportServiceClientReject(error))
    } finally {
        setTimeout(() => { dispatch(postImportServiceClientReset()) }, 3000);
    }
    return Promise.resolve();
};
